import styled from 'styled-components';
import { MBox } from '../atoms/MBox';

export const StyledPopupWidgetCon = styled(MBox)`
  & button {
    appearance: none;
  }

  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  & .mr-popup-widget__products-container {
    flex-grow: 1;
    overflow: auto;

    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
      background-color: transparent;
    }
    ::-webkit-scrollbar-corner {
      background-color: transparent;
      border-color: transparent;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 7px;
      background-color: #c4c4c4;
    }
    ::-webkit-scrollbar-track {
      border-radius: 7px;
      background-color: transparent;
    }
    @media (max-width: 768px) {
      ::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }
      ::-webkit-scrollbar-thumb {
        border-radius: 4px;
      }
      ::-webkit-scrollbar-track {
        border-radius: 4px;
      }
    }
  }

  & .mr-popup-widget__navigation-con {
    display: block !important;
  }

  & .mr-divider {
    display: block !important;
    border-top: 1px solid rgba(34, 47, 62, 0.2);
  }
`;

export const StyledProductItemCon = styled(MBox)`
  display: flex;
  gap: 12px;

  .mr-product-item__body-wrapper {
    display: flex;
    gap: 12px;
    flex-grow: 1;
  }

  .mr-product-item__body {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;
  }

  & .mr-images-carousel {
    min-width: fit-content;
  }
`;
